import { Checkbox, Dropdown, Form, Table } from 'semantic-ui-react';
import { ReportType } from '../../../../constnats/reportConstants';
import {
    RESOURCE_CATEGORIES,
    RESOURCE_SOURCE_TYPES,
    RESOURCE_SOURCE_TYPES_SHORT_FORMS,
} from '../../../../constnats/resourceConstants';
import Assert from '../../../../utils/asserts';
import { MetadataType } from '../../types';

type MetadataFormPropsType = MetadataType & {
    handleChange: (metadata: Partial<MetadataType>) => void;
};

const MetadataForm = ({
    sourceType,
    finDocType,
    reportType,
    note,
    suffix,
    originalOnly,
    handleChange,
}: MetadataFormPropsType) => {
    return (
        <Form>
            <Table compact="very">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Financial Document Type</Table.HeaderCell>
                        <Table.HeaderCell>Source Type</Table.HeaderCell>
                        <Table.HeaderCell>Format</Table.HeaderCell>
                        <Table.HeaderCell collapsing>Note</Table.HeaderCell>
                        <Table.HeaderCell>Suffix</Table.HeaderCell>
                        <Table.HeaderCell collapsing>Original Only</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        <Table.Row>
                            <Table.Cell>
                                <Dropdown
                                    onChange={(__, d) => handleChange({ finDocType: d.value as string })}
                                    value={finDocType}
                                    placeholder="Type"
                                    options={RESOURCE_CATEGORIES.map((c) => {
                                        return { key: c, text: c, value: c };
                                    })}
                                    selection
                                    search
                                />
                            </Table.Cell>
                            <Table.Cell>
                                <Dropdown
                                    onChange={(__, d) => handleChange({ sourceType: d.value as string })}
                                    value={sourceType}
                                    placeholder="Source Type"
                                    options={RESOURCE_SOURCE_TYPES.map((c) => {
                                        Assert.trueVal(!!RESOURCE_SOURCE_TYPES_SHORT_FORMS[c]);
                                        return { key: c, text: c, value: RESOURCE_SOURCE_TYPES_SHORT_FORMS[c] };
                                    })}
                                    selection
                                    search
                                />
                            </Table.Cell>
                            <Table.Cell>
                                <Dropdown
                                    onChange={(__, d) => handleChange({ reportType: d.value as string })}
                                    value={reportType}
                                    placeholder="Type"
                                    options={ReportType.ALL.map((c) => {
                                        return { key: c, text: c, value: c };
                                    })}
                                    selection
                                    search
                                />
                            </Table.Cell>
                            <Table.Cell collapsing>
                                <Checkbox checked={note} onChange={() => handleChange({ note: !note })} />
                            </Table.Cell>
                            <Table.Cell>
                                <Form.Input
                                    placeholder="Suffix"
                                    value={suffix}
                                    onChange={(__, d) => handleChange({ suffix: d.value as string })}
                                />
                            </Table.Cell>
                            <Table.Cell collapsing>
                                <Checkbox
                                    checked={originalOnly}
                                    onChange={() => handleChange({ originalOnly: !originalOnly })}
                                />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>
        </Form>
    );
};

export default MetadataForm;
